import type { AuthWrapperCbProfile } from "@jetblue/auth-wrapper";
import { Link } from "../../../link";
import type { TrueBlueUserProperties } from "./true-blue-user";

export type CreditProfileUserProperties = {
  cta?:
    | {
        href?: string | undefined;
        isExternal?: boolean;
        label?: string | undefined;
        target?: "_blank" | "_self" | undefined;
      }
    | undefined;
  firstName: string;
  labels: { travelCredits: string };
  loyalty: TrueBlueUserProperties["loyalty"];
  travelBankDetails:
    | Partial<AuthWrapperCbProfile["customerDetails"]["travelBankDetails"]>
    | undefined;
};
export const CreditProfileUser = ({
  cta: { href = "", isExternal = false, label = "", target = "_self" } = {},
  firstName,
  labels,
  loyalty,
  travelBankDetails,
}: CreditProfileUserProperties) => (
  <section
    className="
      bg-off-white p-6 text-core-blue

      data-[theme=dark]:bg-core-blue data-[theme=dark]:text-white
    "
    data-fs-element="user-credit-profile-details-section"
    data-theme={loyalty.theme}
  >
    <div className="mb-2 text-center text-body-extra-bold">
      {loyalty.labels.greeting}&nbsp;
      {firstName}
    </div>

    <div className="mt-3 text-center text-charcoal">
      <div className="text-center text-legal">
        <div className="text-legal">{labels.travelCredits}</div>

        <div className="text-body-extra-bold">
          {travelBankDetails?.balance?.amount}
        </div>
      </div>
    </div>

    {href && label && (
      <div className="mt-2 flex justify-center text-charcoal">
        <Link
          className="
            w-fit text-legal font-bold text-royal-blue focus-outline

            hover:text-core-blue hover:underline
          "
          data-fs-element="user-credit-profile-details-cta-link"
          href={href}
          isExternal={isExternal}
          showArrowRight
          target={target}
        >
          {label}
        </Link>
      </div>
    )}
  </section>
);
